import { AfterViewInit, Component, OnDestroy, computed, effect, input, model } from "@angular/core"
import { NgClass } from "@angular/common"
import { FormValueControl } from "@angular/forms/signals"
import * as L from "leaflet"
import { Geolocation } from "src/app/models"

const iconRetinaUrl = "assets/marker-icon-2x.png"
const iconUrl = "assets/marker-icon.png"
const shadowUrl = "assets/marker-shadow.png"
const iconDefault = L.icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
})
L.Marker.prototype.options.icon = iconDefault

@Component({
    selector: "valben-location-input",
    templateUrl: "./location-input.component.html",
    styles: [
        `
            .map-container {
                position: relative;
                min-width: 500px;
                width: 35%;
                height: 500px;
            }

            .map-frame {
                height: 100%;
            }

            .map-component {
                height: 100%;
            }
        `,
    ],
    standalone: true,
    imports: [NgClass],
})
export class LocationInputComponent implements FormValueControl<Geolocation>, AfterViewInit, OnDestroy {
    value = model.required<Geolocation>()
    title = input("")
    error = input(false)
    invalid = input(false)

    hasError = computed(() => this.error() || this.invalid())

    mapId = `map-${Math.random().toString(16).slice(2)}`

    private _map: L.Map | undefined
    private _marker: L.Marker | undefined

    constructor() {
        effect(() => {
            const value = this.value()
            this._syncMarker(value)
        })
    }

    ngAfterViewInit(): void {
        this._map = L.map(this.mapId, {
            center: [45.2033, 13.9114],
            zoom: 7,
        })

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 18,
            minZoom: 8,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            referrerPolicy: "strict-origin-when-cross-origin",
        }).addTo(this._map)

        this._map.on("click", (e: L.LeafletMouseEvent) => {
            this.value.set({ latitude: e.latlng.lat, longitude: e.latlng.lng })
        })

        this._syncMarker(this.value())
    }

    ngOnDestroy(): void {
        this._map?.remove()
    }

    removeLocation(): void {
        this.value.set({ latitude: null, longitude: null })
    }

    private _syncMarker(value: Geolocation | null | undefined): void {
        if (!this._map) return

        if (this._marker) {
            this._map.removeLayer(this._marker)
            this._marker = undefined
        }

        const latitude = value?.latitude
        const longitude = value?.longitude
        if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) return

        this._marker = L.marker(L.latLng(latitude, longitude)).addTo(this._map)
    }
}
